import { Route, Routes } from 'react-router-dom'

type RoutableTab = {
  key: string
  path: string
  component?: React.ComponentType
  childRoutes?: Array<{
    key: string
    path: string
    component?: React.ComponentType
  }>
}

export interface TabsRouteMappingProps {
  tabsForRouting: RoutableTab[]
}

export const TabsRouteMapping = ({ tabsForRouting }: TabsRouteMappingProps) => {
  return (
    <Routes>
      {tabsForRouting.map(t => {
        const Comp = t.component
        if (t.childRoutes && t.childRoutes.length) {
          return (
            <Route key={t.key} path={t.path} element={Comp ? <Comp /> : <></>}>
              {t.childRoutes.map(childRoute => {
                const ChildComp = childRoute.component
                return (
                  <Route
                    key={childRoute.key}
                    path={childRoute.path}
                    element={ChildComp ? <ChildComp /> : <></>}
                  />
                )
              })}
            </Route>
          )
        } else {
          return (
            <Route
              key={t.key}
              path={t.path}
              element={Comp ? <Comp /> : <></>}
            />
          )
        }
      })}
    </Routes>
  )
}
